import API from "./index";

export const getEncounters = (data: any) => API.handleApiRequest(() => API.post(`encounter/task-encounter`, data))